import './StatusSubmitButton.scss'

import React, { Component } from 'react'

export class StatusSubmitButton extends Component {

  state = {
    isDebouncing: false
  }

  debounceTimeout = null

  debouncedOnClick = () => {
    const { onClick } = this.props
    const { isDebouncing } = this.state

    if (isDebouncing) {
      return
    }
    this.setState({ isDebouncing: true })

    onClick()

    this.debounceTimeout = setTimeout(() => {
      this.setState({ isDebouncing: false })
    }, 1000)
  }

  componentWillUnmount() {
    clearTimeout(this.debounceTimeout)
  }

  render() {
    const { children, className, onBackClick, disabled, ...buttonProps } = this.props
    const { isDebouncing } = this.state

    return (
      <div className={`StatusSubmitButton ${className || ''}`}>
        {!!onBackClick && <button className="StatusSubmitButton__back" onClick={onBackClick}>&lt; Back</button>}
        <button {...buttonProps} disabled={disabled || isDebouncing} onClick={this.debouncedOnClick}>{children}</button>
      </div>
    )
  }
}
